// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingRemovePromoCodeResponse

import { hydrateWidgetBookingPriceSummary, type WidgetBookingPriceSummary, type WidgetBookingPriceSummaryApiResponse } from './widgetBookingPriceSummary.gen';

export type BookingRemovePromoCodeApiResponse = {
	success: boolean;
	priceSummary: WidgetBookingPriceSummaryApiResponse;
};

export type BookingRemovePromoCode = {
	success: boolean;
	priceSummary: WidgetBookingPriceSummary;
};

export function hydrateBookingRemovePromoCode(data: BookingRemovePromoCodeApiResponse): BookingRemovePromoCode {
	return {
		...data,
		priceSummary: hydrateWidgetBookingPriceSummary(data.priceSummary),
	};
}